export default __webpack_public_path__ + "static/media/6.871aee42.webp";